<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-30 14:20:08
 * @LastEditTime: 2020-09-07 10:49:10
 * @Description: 销售订单详情Drawer
-->
<template>
  <Drawer width="1000" title="销售订单" v-model="drawerOpened">
    <div class="drawer-content">
      <div class="info-panel">
        <div class="steps-block">
          <Steps :current="currentStep" size="small">
            <Step title="下单"></Step>
            <Step title="生产"></Step>
            <Step title="运输"></Step>
            <Step title="已收货"></Step>
          </Steps>
        </div>

        <SecSO ref="SecSO" />
        <SecSPO ref="SecSPO" />
        <SecDelivery ref="SecDelivery" />
      </div>

      <div class="comment-panel">
        <CommentPanel ref="CommentPanel" />
      </div>
    </div>
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import SecSO from "./SecSO.vue";
import SecSPO from "./SecSPO.vue";
import SecDelivery from "./SecDelivery";
import CommentPanel from "./CommentPanel.vue";

export default {
  name: "SODrawer",
  components: {
    SecSO,
    SecSPO,
    SecDelivery,
    CommentPanel,
  },
  data() {
    return {
      drawerOpened: false,
      salesOrder: null,
    };
  },
  computed: {
    currentStep() {
      if (this.salesOrder) {
        if (this.salesOrder.arrivedAt) return 3;
        if (this.salesOrder.startedAt && !this.salesOrder.finishedAt) return 1;
        if (this.salesOrder.startedAt && this.salesOrder.finishedAt) return 2;
      }
      return 0;
    },
  },
  methods: {
    openDrawer(salesOrder) {
      this.drawerOpened = true;
      this.salesOrder = salesOrder;
      this.$refs.SecSO.loadData({ salesOrder: this.salesOrder });
      this.$refs.SecSPO.loadData({ SPO: this.salesOrder });
      this.$refs.SecDelivery.loadData({
        delivery: this.salesOrder.delivery,
        SPO: this.salesOrder,
      });
      this.$refs.CommentPanel.loadData({ salesOrder: this.salesOrder });
    },
    finishEdit() {
      this.editSOPanelOpened = false;
    },
  },
  watch: {},
};
</script>

<style scoped lang="stylus">
.info-panel
  height 100%
  width 718px
  float left
  overflow-y auto

.comment-panel
  height 100%
  width 250px
  float left

.steps-block
  width 100%
  height 48px
</style>
